import { render } from "./PaginatedTables.vue?vue&type=template&id=6fa0e87a"
import script from "./PaginatedTables.vue?vue&type=script&lang=js"
export * from "./PaginatedTables.vue?vue&type=script&lang=js"

import "./PaginatedTables.vue?vue&type=style&index=0&id=6fa0e87a&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__